<template>
  <div class="comment_list">
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <img :src="item.userhead" alt="" />
        <div class="comment_desc">
          <div class="comment_tips">
            <span>{{item.username}}</span>
            <span>{{parseTime(item.createtime,"{y}-{m}-{d}")}}</span>
          </div>
          <div class="comment_content">
             {{item.cmsg}}
          </div>
        </div>
      </li>
    </ul>
    <div class="get_more" @click="loadMore">
      <span>加载更多</span>
    </div>
  </div>
</template>

<script>
import {parseTime} from '@/utils';
export default {
  props:{
    list:{
      type:Array
    }
  },
  created(){
  },
  methods:{
    parseTime(){
        return parseTime(...arguments)
    },
    loadMore(){
      this.$emit("loadMore")
    }
  }
};
</script>

<style scoped lang='less'>
.comment_list {
  ul {
    margin-top: 20px;
    li {
      display: flex;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #eeeeee;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .comment_desc {
        width: 89%;
        .comment_tips {
          display: flex;
          justify-content: space-between;
          width: 100%;
          span {
            &:nth-of-type(1) {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
            &:nth-of-type(2) {
              font-size: 14px;
              font-family: Arial;
              font-weight: 400;
              color: #999999;
            }
          }
        }
        .comment_content {
          margin-top: 10px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
		  width: 100%;
		  word-wrap: break-word;
		  word-break: break-all;
		  overflow: hidden;
		  /* display: -webkit-box;
		  -webkit-box-orient: vertical;
		  -webkit-line-clamp: 3;
		  overflow: hidden; */
        }
      }
    }
  }
  .get_more {
    margin: 20px 0 40px;
    text-align: center;
    span {
      position: relative;
      display: inline-block;
      padding: 10px 20px;
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      &::before {
        position: absolute;
        right: 0;
        top: 12px;
        display: inline-block;
        width: 15px;
        height: 15px;
        content: "";
        background: url("../assets/images/more.png") no-repeat center/100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/commentList.vue